import _ from 'lodash';
import { asyncRoutes, staticRoutes, whiteList } from 'app/configs/routesConfig';

export const mergeRoutes = (currentRoutes = [], newRoutes = []) =>
  _.unionBy([...currentRoutes, ...newRoutes], 'path');

export const getPublicRoutes = () => asyncRoutes.filter((route) => whiteList.includes(route.path));

export const getProtectedRoutes = () =>
  asyncRoutes.filter((route) => !whiteList.includes(route.path));

export const getStaticRoutes = () => staticRoutes;

export const getAsyncFilteredRoutes = () => {
  const temporal = getPublicRoutes();
  return mergeRoutes(staticRoutes, temporal);
};
